import React, { useContext } from "react";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillEye, AiFillLock } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import AuthContext from "context/AuthContext";
import { isEmpty, startCase } from "lodash";
import helper from "../../utils/helpers";
import { NavLink } from "react-router-dom";
import OImage from "components/reusable/OImage";
import userAvatar from "../../assets/images/userAvatar.png";
const AgentTable = ({
  agent,
  handelEdit,
  allAgent,
  page,
  sort,
  setSort,
  paginationObj,
  manager,
  handleResetPassword,
}) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const notification = useToastContext();
  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.statusAgent}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allAgent();
      }
      // }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };

  return (
    <div className="p-3">
      <div
        className="overflow-x-auto relative 
 border"
      >
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6 text-center">
                #
              </th>
              <th scope="col" className="py-3 px-6 cursor-pointer">
                <div className="flex">
                  <span>{t("O_PROFILE_PICTURE")} </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortKey === "name" && sort.sortType === "asc") {
                    setSort({
                      sortKey: "name",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "name",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_FULL_NAME")} </span>
                  <span>
                    {sort.sortKey === "name" && sort.sortType === "asc" && (
                      <BsArrowUpShort className="w-4 h-4" />
                    )}
                    {sort.sortKey === "name" && sort.sortType === "desc" && (
                      <BsArrowUpShort className="w-4 h-4 rotate-180" />
                    )}
                  </span>
                </div>
              </th>

              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortKey === "email" && sort.sortType === "asc") {
                    setSort({
                      sortKey: "email",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "email",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_EMAIL_ADDRESS")} </span>
                  <span>
                    {sort.sortKey === "email" && sort.sortType === "asc" && (
                      <BsArrowUpShort className="w-4 h-4" />
                    )}
                    {sort.sortKey === "email" && sort.sortType === "desc" && (
                      <BsArrowUpShort className="w-4 h-4 rotate-180" />
                    )}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-right">
                {t("AGENT_TYPE")}
              </th>
              <th scope="col" className="py-3 px-6 text-right">
                {t("O_COUNTRY_CODE")}
              </th>
              <th scope="col" className="py-3 px-6 text-right">
                {t("O_MOBILE")}
              </th>
              <th scope="col" className="py-3 px-6 text-right">
                {t("O_BRN_NUMBER")}
              </th>
              <th scope="col" className="py-3 px-6 text-right">
                {t("AGENT_DESIGNATION")}
              </th>
              <th scope="col" className="py-3 px-6 text-center">
                {t("No. of property")}
              </th>

              <th
                scope="col"
                className="py-3 px-6 cursor-pointer text-right"
                onClick={() => {
                  if (sort.sortKey === "createdAt" && sort.sortType === "asc") {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-end">
                  <span>{t("O_CREATED_AT")} </span>
                  <span>
                    {sort.sortKey === "createdAt" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortKey === "createdAt" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>

              <th
                scope="col"
                className="py-3 px-6 cursor-pointer text-right"
                onClick={() => {
                  if (sort.sortKey === "updatedAt" && sort.sortType === "asc") {
                    setSort({
                      sortKey: "updatedAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "updatedAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-end">
                  {t("O_UPDATED_AT")}
                  {sort.sortKey === "updatedAt" && sort.sortType === "asc" && (
                    <BsArrowUpShort className="w-4 h-4" />
                  )}
                  {sort.sortKey === "updatedAt" && sort.sortType === "desc" && (
                    <BsArrowUpShort className="w-4 h-4 rotate-180" />
                  )}
                </div>
              </th>
              {(manager?.add || user?.role === "admin") && (
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_STATUS")}
                </th>
              )}
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {agent &&
              agent?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-2 px-2 text-center border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>
                  <td className="py-2 px-2 border-r text-center">
                    <figure className="inline-block overflow-hidden rounded-full border-2 mb-0">
                      <OImage
                        src={item?.profilePic ?? userAvatar}
                        fallbackUrl={userAvatar}
                        className="w-10 h-10"
                      />
                    </figure>
                  </td>
                  <td className="py-2 px-2 border-r">{item?.name} </td>
                  <td className="py-2 px-2 border-r">{item?.email}</td>
                  <td className="py-2 px-2 border-r">
                    {startCase(item?.parentType)}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {item?.countryCode}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {item?.mobile}{" "}
                  </td>
                  <td className="py-2 px-2 border-r">{item?.brn || "N/A"}</td>
                  <td className="py-2 px-2 border-r">{item?.designation}</td>
                  <td className="py-2 px-2 border-r text-center">
                    {item?.propertyCount}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {helper.dateFormat(item?.updatedAt)}{" "}
                  </td>
                  {(manager?.add || user?.role === "admin") && (
                    <td className="py-2 px-2 border-r text-center">
                      <label
                        className="inline-flex relative items-center cursor-pointer"
                        // title={t('O_STATUS')}
                        title={`${
                          item?.status === "active" ? "Active" : "Inactive"
                        }`}
                      >
                        <input
                          type="checkbox"
                          // value={status}
                          className="sr-only peer"
                          checked={item?.status === "active"}
                          onChange={(e) =>
                            helper.alertFunction(
                              `Are you sure want to ${
                                e.target.checked ? "active" : "inactive"
                              } ${item.name}?`,
                              item,
                              handelStatusChange,
                            )
                          }
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                      </label>
                    </td>
                  )}
                  <td className="py-2 px-2 border-l">
                    <div className="">
                      <ul className="flex justify-center">
                        {(manager?.add || user?.role === "admin") && (
                          <li
                            onClick={() => handelEdit(item)}
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                          >
                            <button title={t("O_EDIT")}>
                              {" "}
                              <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                            </button>
                          </li>
                        )}
                        {(manager?.add || user?.role === "admin") && (
                          <li
                            onClick={() => handleResetPassword(item)}
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                          >
                            <button title={t("O_RESET_PASSWORD")}>
                              <AiFillLock className="w-5 h-5 text-slate-600" />
                            </button>
                          </li>
                        )}
                        <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                          <NavLink
                            title={t("O_VIEW_USER")}
                            to="/agents/view"
                            state={{ item }}
                          >
                            <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(agent) ? (
              <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-2 px-2" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AgentTable;
